module.exports = __webpack_public_path__ + "img/cp-8.6183428f.jpg";